import React from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"

const Container = styled.div`
  width: 100%;
  padding: 0 20px;

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
  }

  @media (min-width: ${breakpoints.lg}) {
    padding: 0 ${(props) => (props.header ? "40px" : "46px")};
  }
`

const Content = styled.div`
  margin: auto;
  max-width: ${breakpoints.xxl};
  max-width: calc(1600px - 92px);
`

const BlockContainer = ({ children, lg, header = false, ...rest }) => {
  return (
    <Container header={header ? 1 : 0}>
      <Content {...rest}>{children}</Content>
    </Container>
  )
}

export default BlockContainer
